if (!customElements.get('lx-gallery')) customElements.define('lx-gallery', class extends HTMLElement {
  connectedCallback() {
    if(this.bound)return;
    this.bound=true;
    this.map=JSON.parse(this.querySelector('[data-gallery-map]').textContent);
    this.image=this.querySelector('.lx-gallery__main img');
    this.main=this.querySelector('.lx-gallery__main');
    this.thumbs=this.querySelector('.lx-gallery__thumbs');
    this.caption=this.querySelector('.lx-gallery__caption');
    this.dialog=this.querySelector('dialog');
    this.rail=document.createElement('div');this.rail.className='lx-gallery-rail';this.thumbs.before(this.rail);
    this.previous=document.createElement('button');this.previous.type='button';this.previous.className='lx-gallery-arrow';this.previous.textContent='←';
    this.next=document.createElement('button');this.next.type='button';this.next.className='lx-gallery-arrow';this.next.textContent='→';
    this.rail.append(this.previous,this.thumbs,this.next);
    this.previous.addEventListener('click',()=>this.step(-1));this.next.addEventListener('click',()=>this.step(1));
    this.main.addEventListener('click',()=>this.enlarge());
    this.querySelector('.lx-gallery__close').addEventListener('click',()=>this.dialog.close());
    this.dialog.addEventListener('click',e=>{if(e.target===this.dialog)this.dialog.close()});
    this.main.addEventListener('pointerdown',e=>{this.pointerStart={x:e.clientX,y:e.clientY}});
    this.main.addEventListener('pointerup',e=>{
      if(!this.pointerStart)return;
      const dx=e.clientX-this.pointerStart.x,dy=e.clientY-this.pointerStart.y;this.pointerStart=null;
      if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.4){this.suppressClick=true;this.step(dx<0?1:-1)}
    });
    this.main.addEventListener('pointercancel',()=>{this.pointerStart=null});
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
      if(String(event.data.sectionId)!==String(this.dataset.sectionId))return;
      if(this.map[event.data.variant.id])this.map[event.data.variant.id].available=event.data.variant.available;
      this.selectVariant(event.data.variant.id);this.syncPresentation();lxEnhance();
    });
    this.onVariantInput=event=>{
      if(event.target instanceof HTMLInputElement&&event.target.matches('input[name="id"]')&&event.target.closest('product-info')===this.closest('product-info'))this.selectVariant(event.target.value);
    };
    document.addEventListener('change',this.onVariantInput);
    this.selectVariant(this.dataset.variantId);
  }
  disconnectedCallback(){this.unsubscribe?.();document.removeEventListener('change',this.onVariantInput)}
  selectVariant(id){
    id=String(id);if(!this.map[id]||this.activeVariant===id)return;
    this.activeVariant=id;this.item=this.map[id];this.position=0;this.syncPresentation();
    this.previous.setAttribute('aria-label',this.item.previous);this.next.setAttribute('aria-label',this.item.next);
    this.thumbs.replaceChildren();
    this.item.images.forEach((image,pos)=>{
      const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',image.label);
      const i=document.createElement('img');i.src=image.thumb;i.alt='';i.width=180;i.height=180;i.loading='lazy';
      b.append(i);b.addEventListener('click',()=>{this.position=pos;this.paint()});this.thumbs.append(b);
    });
    this.thumbs.scrollLeft=0;this.paint();
  }
  step(amount){this.position=(this.position+amount+this.item.images.length)%this.item.images.length;this.paint()}
  syncPresentation(){
    const host=this.closest('product-info');if(!host)return;
    host.dataset.lxSku=this.item.sku;host.dataset.lxAvailable=String(this.item.available);
    host.querySelectorAll('.lx-product-pack').forEach(e=>e.textContent=this.item.variant);
    host.querySelectorAll('.lx-product-name-full').forEach(e=>e.textContent=this.item.name);
    host.querySelectorAll('.lx-product-name-short').forEach(e=>e.textContent=this.item.name.replace(' Lubricant',''));
    lxEnhance(host);
  }
  paint(){
    if(!this.item)return;
    const image=this.item.images[this.position];
    if(image.small){this.image.srcset=image.small+' 600w, '+image.src+' 1200w';this.image.sizes='(min-width: 990px) 50vw, (min-width: 750px) 45vw, 100vw';this.image.src=image.small}
    else{this.image.removeAttribute('srcset');this.image.removeAttribute('sizes');this.image.src=image.src}
    this.image.alt=image.alt;this.image.draggable=false;this.main.dataset.role=image.role;
    this.caption.textContent=image.caption;this.main.setAttribute('aria-label',image.enlarge);
    [...this.thumbs.children].forEach((b,p)=>b.setAttribute('aria-pressed',String(p===this.position)));
  }
  enlarge(){
    if(this.suppressClick){this.suppressClick=false;return}
    const image=this.item.images[this.position],zoom=this.dialog.querySelector('img');
    zoom.src=image.src;zoom.alt=image.alt;this.dialog.querySelector('.lx-gallery__zoom-caption').textContent=image.caption;
    this.dialog.showModal();
  }
});

function lxEnhance(root=document){
 root.querySelectorAll('variant-selects fieldset').forEach(field=>{const count=field.querySelectorAll('input[type="radio"]').length;field.dataset.lxOptionCount=String(count);field.classList.toggle('is-single-option',count===1)});
 document.querySelectorAll('.lx-collection-categories a').forEach(a=>{if(new URL(a.href).pathname===location.pathname)a.setAttribute('aria-current','page')});
 const title=document.querySelector('main .title-wrapper-with-link .title');if(location.pathname.endsWith('/cart')&&title)title.textContent='Your bag of possibilities.';
 const empty=document.querySelector('.cart__empty-text');if(empty)empty.textContent='Your bag’s behaving. For now.';
 document.querySelectorAll('input[type="search"]').forEach(input=>input.placeholder='Find your kind of play');
}
document.addEventListener('click',event=>{const trigger=event.target.closest('[data-lx-packing-open]');if(trigger)document.getElementById('lx-packing-dialog')?.showModal();if(event.target.closest('[data-lx-packing-close]'))document.getElementById('lx-packing-dialog')?.close()});
const lxPackingDialog=document.getElementById('lx-packing-dialog');lxPackingDialog?.addEventListener('click',event=>{if(event.target===lxPackingDialog)lxPackingDialog.close()});
document.addEventListener('shopify:section:load',()=>lxEnhance());
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>lxEnhance());else lxEnhance();
